module.exports = __webpack_public_path__ + "img/qoute.119cbe71.svg";